import React from 'react'
import styled from 'styled-components'
import RequiredFieldMark from '../particles/RequiredFieldMark'


export const Wrapper = styled.div`
    /* background: red; */
    position: relative;
    width: ${props => props.$size === 'full' ? '100%' 
        : props.$size === 'large' ? '250px'
            : props.$size === 'medium' ? '210px'
                : props.$size === 'small' ? '150px'
                    : 'none'
    };
    height: 3.5em;
    border-radius: 30px;
`
export const Select = styled.select`
    width: 100%;
    height: 100%;
    border-radius: 30px;
    outline: none;
    border: none;
    font-size: 1em;
    background: #eff3f4;
    padding: 0 1em;
    appearance: none;
    direction: rtl;
    cursor: pointer;
    color: #8a97ac;
    font-size: 1.1em;
`
export const SelectedIndicator = styled.div`
    position: absolute;
    top: -0.1em;
    right: -0.1em;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    background: tomato;
`
/**
 * @param {any} props
 */
export default function SelectFromTheList(props) {
    const {
        lable = 'select',
        list,
        dispalyFieldName = 'text',
        itemKey = 'id',
        fieldValue = 'id',
        required = false,
        tabIndex,
        selectFunction,
        defaultValue,
        selectedValue,
        size = 'medium',
        disableSelectedMark = false,
        dispalyFieldNameSecond,
        disabled = false
    } = props;
  return (
    <Wrapper
        $size={size}
    >
        {
            !!selectedValue && !disableSelectedMark && <SelectedIndicator />
        }
        <RequiredFieldMark visible={required} />
        <Select
            onChange={e => {selectFunction(e.target.value)}}
            value={selectedValue || defaultValue || ''}
            tabIndex={tabIndex}
            disabled={disabled}
        >
            <option value={''}>{lable}</option>
            {
                list?.map(item => 
                    <option 
                        key={item[itemKey]}
                        value={item[fieldValue]}
                    >
                        {
                            `
                                ${item[dispalyFieldName]?.trim()} 
                                ${dispalyFieldNameSecond && item[dispalyFieldNameSecond] ? `(${item[dispalyFieldNameSecond]})` : ''}
                            `
                            }
                    </option>
                )
            }
        </Select>
    </Wrapper>
  )
}

